import device from './device';
import inspect from './inspect';
import inspectTask from './inspectTask';
import inspectTaskRecord from './inspectTaskRecord';
import other from './other';
import push from './push';
import sys from './sys';
import safety from './safety';
import workOrder from './workOrder';
import weather from './weather';
import linkage from './linkage';
import linkageRules from './linkage/linkageRules';
import ota from './ota';
import datav from './datav';
import planePosition from './planePosition';
import prospect from './prospect';
import order from  './order'
import pay from  './pay';
import snapshot from './snapshot';
import enterprise from './enterprise';

/**
 * 这里包含了所有接口
 */
export default {
    device, inspect, inspectTask, inspectTaskRecord,
    other, push, sys, workOrder, weather, linkage,
    ota, datav, planePosition, safety, prospect,order,
    pay,linkageRules,snapshot,enterprise
};